import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/articles';

export default function BlogPreview() {
  const handleArticleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wider uppercase mb-3">
            Expert Content
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Latest Spreadsheet Guides
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            Expert tips and curated insights for smarter shopping across all categories
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              onClick={handleArticleClick}
              className="block w-full text-left bg-background-50 rounded-2xl overflow-hidden group transition-all duration-300 hover:-translate-y-1 border border-transparent hover:border-background-200"
            >
              <div className="relative w-full h-[220px] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {article.isNew && (
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs font-semibold">
                    New
                  </span>
                )}
                <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                  {article.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">
                    {article.date} &bull; {article.readTime}
                  </span>
                  <span className="text-primary-500 text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-foreground-400 text-sm">
            Showing all {blogArticles.length} guides & articles
          </p>
        </div>
      </div>
    </section>
  );
}